import {
    select as D3select,
    scaleLinear as D3scaleLinear,
    forceSimulation as D3forceSimulation,
    forceManyBody as D3forceManyBody,
    forceCenter as D3forceCenter,
    forceLink as D3forceLink,
    extent as D3extent,
    drag as D3drag,
    timer as D3timer,
    easeBounce as D3easeBounce,
    easeSin as D3easeSin,
} from 'd3';
import D3Tooltips from './D3Tooltips.js';
import { /*teal,*/ olive } from '../data/colors.js';

const noop = () => {};

// const teals = Object.values(teal);
// const getNextColor = i => {
//     return teals[i % teals.length - 1];
// };

const D3SeaUrchin = function () {
    // component overridable properties
    let theme;
    let width = 100;
    let height = 100;
    const radius = 12;
    let settings = {
        MARGIN: 20,
        DURATION: 400,
        colors: ['black']
    };
    let onClickHandler = noop;
    let onAltClickHandler = noop;
    let onDblClickHandler = noop;
    let onSClickHandler = noop;

    let tooltip = D3Tooltips();

    function my (selection) {
        if (!selection) return;
        selection.each(function (graph, i) {
            // scales
            const area = D3scaleLinear()
                .range([12, 315])
                .domain(D3extent(graph.nodes, d => d.count));
            const r = d => Math.sqrt(area(d) / Math.PI);
            const w = D3scaleLinear()
                .range([1, 8])
                .domain(D3extent(graph.links, d => d.count));

            const labelGap = 17;

            // DOM  ************************************************************
            const g = D3select(this).selectAll('.directedgraph').data([graph.key]);
            const genter = g.enter()
                .append('g')
                .attr('class', 'directedgraph');
            const gmerge = genter.merge(g);
            g.exit().remove();

            const labelsj = gmerge.selectAll('.labels').data([graph.key]);
            const labelg = labelsj.enter().append('g')
                .attr('class', 'labels')
                .merge(labelsj);
            labelsj.exit().remove();

            const linksj = gmerge.selectAll('.links').data([graph.key]);
            const linkg = linksj.enter().append('g')
                .attr('class', 'links')
                .merge(linksj);
            linksj.exit().remove();

            const nodesj = gmerge.selectAll('.nodes').data([graph.key]);
            const nodesg = nodesj.enter().append('g')
                .attr('class', 'nodes')
                .merge(nodesj);
            nodesj.exit().remove();

            const linkj = linkg.selectAll('line')
                .data(graph.links, d => d.source.id + '->' + d.target.id);
            const links = linkj.enter().append('line')
                .merge(linkj)
                .attr('stroke-width', d => w(d.count))
                .attr('stroke', theme.ChartColors[1]);
            linkj.exit().remove();

            const nodej = nodesg.selectAll('circle')
                .data(graph.nodes, d => d.id);
            const nodes = nodej.enter().append('circle')
                .merge(nodej)
                .attr('class', 'node cursor')
                .attr('r', d => r(d.count))
                .attr('fill', (d, i) => d.breadcrumb ? olive[400] : theme.ChartColors[0])
                .attr('stroke', (d, i) => d.home ? 'black' : d.breadcrumb ? olive[400] : theme.ChartColors[0]);
                // .attr('fill', (d, i) => d.breadcrumb ? theme.ChartColors[2] : theme.ChartColors[0])
                // .attr('stroke', (d, i) => d.home ? 'black' : d.breadcrumb ? theme.ChartColors[2] : theme.ChartColors[0]);

            nodej.exit().remove();

            const labelj = labelg.selectAll('text')
                .data(graph.nodes, d => d.id);
            const labels = labelj.enter().append('text')
                .attr('class', 'node-title cursor')
                .merge(labelj)
                .text(d => d.asset)
                .attr('dy', 4);
            labelj.exit().remove();

            // add the tooltip once
            tooltip = tooltip.theme(theme);
            const tipj = gmerge.selectAll('.directedgraph-tip').data([graph.key]);
            tipj.enter().append('g')
                .attr('class', 'directedgraph-tip')
                .merge(tipj)
                .call(tooltip.bounds({ width, height }));
            tipj.exit().remove();

            // simulation  *****************************************************
            const simulation = D3forceSimulation()
                .nodes(graph.nodes);
            simulation
                .force('charge', D3forceManyBody())
                .force('center', D3forceCenter(width / 2, height / 2))
                .force('link', D3forceLink().id((d) => d.id)
                    .distance(Math.min(width / 4, height / 4)) // .distance(80)
                    .links(graph.links))
                .force('boxForce', boxForce);

            simulation.force('charge').strength(-100);
            simulation.on('tick', ticked);

            // prevent 'gravity' from pulling the nodes outside the graph
            function boxForce (alpha) {
                graph.nodes.forEach(d => {
                    d.x = Math.max(100, Math.min(width - 75, d.x));
                    d.y = Math.max(100, Math.min(height - 50, d.y));
                });
            }

            function ticked () {
                links
                    .attr('x1', (d) => d.source.x || 0)
                    .attr('y1', (d) => d.source.y || 0)
                    .attr('x2', (d) => d.target.x || 0)
                    .attr('y2', (d) => d.target.y || 0);

                nodes
                    .attr('cx', (d) => d.x || 0)
                    .attr('cy', (d) => d.y || 0);

                // spread labels out
                labels
                    .attr('x', (d) => d.x || 0)
                    .attr('y', (d) => d.y || 0)
                    .attr('dx', (d) => (d.x || 0) >= width / 2 ? labelGap : -labelGap)
                    .attr('text-anchor', (d) => (d.x || 0) >= width / 2 ? 'start' : 'end');
            }

            function isConnected (k) {
                return Object.keys(nsel).concat(Object.keys(lsel))
                    .some(d => {
                        if (k === d) return true;
                        if (graph.connm[k] && graph.connm[k][d]) return true;
                        if (graph.connm[d] && graph.connm[d][k]) return true;
                        return false;
                    }) || Object.keys(lksel).some(lk => lk.split(',').some(d => k === d));
            }

            // behavior ********************************************************
            // disambiguate click from drag
            let dragging;
            // disambiguate dblclick from click
            let dblclicking;

            // pulsate nodes on hover.
            // you have to exit both node and label to deselect.
            const nsel = {};
            const lsel = {};
            const lksel = {};
            nodes
                .on('mouseenter', nodeEnter)
                .on('mouseleave', nodeExit)
                .on('click', nodeClick)
                .on('dblclick', nodeDblClick)
                .call(D3drag()
                    .on('start', dragstarted)
                    .on('drag', dragged)
                    .on('end', dragended));
            labels.on('mouseenter', labelEnter)
                .on('mouseleave', labelExit);
            links.on('mouseenter', linkEnter)
                .on('mouseleave', linkExit);

            function nodeEnter () {
                const d = D3select(this).datum();
                nsel[d.key] = true;
                if (d.key !== d.asset) {
                    tooltip.move(d.x, d.y - 30, [[d.key]]);
                }
                select();
            }

            function nodeExit () {
                const d = D3select(this).datum();
                delete nsel[d.key];
                tooltip.hide();
                select();
            }

            // delay the click to prevent in case we're in a double click
            function nodeClick (e) {
                const d = D3select(this).datum();
                const jnode = D3select(this)._groups[0];
                const t = D3timer((e) => {
                    t.stop();
                    // first condition prevents the first click, second the second
                    if (!dblclicking || (new Date()).getTime() - dblclicking > 500) {
                        dblclicking = undefined;
                        callClickHandler(d, e, jnode);
                    }
                }, 300);
            }

            function nodeDblClick () {
                dblclicking = (new Date()).getTime();
                const d = D3select(this).datum();
                onDblClickHandler(d);
            }

            function callClickHandler (d, e, jnode) {
                jnode = jnode || D3select(this)._groups[0];
                if (e.altKey) onAltClickHandler(d, jnode);
                else if (e.shiftKey) onSClickHandler(d, jnode);
                else onClickHandler(d, jnode);
            }

            function labelEnter () {
                const d = D3select(this).datum();
                lsel[d.key] = true;
                if (d.key !== d.asset) {
                    tooltip.move(d.x, d.y - 30, [[d.key]]);
                }
                select();
            }

            function labelExit () {
                const d = D3select(this).datum();
                delete lsel[d.key];
                tooltip.hide();
                select();
            }

            function linkEnter () {
                const d = D3select(this).datum();
                lksel[d.source.key + ',' + d.target.key] = true;
                select();
            }

            function linkExit () {
                const d = D3select(this).datum();
                delete lksel[d.source.key + ',' + d.target.key];
                select();
            }

            function dragstarted (e, d) {
                if (!e.active) simulation.alphaTarget(1).restart();
                d.fx = d.x;
                d.fy = d.y;
            }

            function dragged (e, d) {
                // prevent dragging outside the graph
                d.fx = Math.max(radius, Math.min(width - 75, e.x));
                d.fy = Math.max(radius, Math.min(height - 50, e.y));
                if (!dragging) {
                    dragging = true;
                    d.fixed = !e.sourceEvent.shiftKey;
                }
            }

            function dragended (e, d) {
                if (!e.active) simulation.alphaTarget(0);
                if (!d.fixed) {
                    d.fx = null;
                    d.fy = null;
                }
                dragging = false;
            }

            // in-transitions only. out transitions cause selection confusion.
            function select () {
                // bounce
                nodes.filter(d => isConnected(d.key))
                    .transition().duration(200)
                    .attr('r', radius * 5 / 3)
                    .ease(D3easeSin)
                    .transition().duration(800)
                    .attr('r', radius)
                    .ease(D3easeBounce);

                // deselect
                nodes.filter(d => !isConnected(d.key))
                    .transition().duration(400)
                    .attr('r', d => r(d.count));
            }
        });
    }
    // getters/setters
    my.width = function (v) {
        if (!arguments.length) return width;
        width = v;
        return my;
    };

    my.height = function (v) {
        if (!arguments.length) return height;
        height = v;
        return my;
    };

    my.settings = function (v) {
        if (!arguments.length) return settings;
        settings = v;
        return my;
    };

    my.onClickHandler = function (v) {
        if (!arguments.length) return onClickHandler;
        onClickHandler = v;
        return my;
    };

    my.onAltClickHandler = function (v) {
        if (!arguments.length) return onAltClickHandler;
        onAltClickHandler = v;
        return my;
    };

    my.onDblClickHandler = function (v) {
        if (!arguments.length) return onDblClickHandler;
        onDblClickHandler = v;
        return my;
    };

    my.onSClickHandler = function (v) {
        if (!arguments.length) return onSClickHandler;
        onSClickHandler = v;
        return my;
    };

    my.theme = function (v) {
        if (!arguments.length) return theme;
        theme = v || theme;
        return my;
    };

    return my;
};

export default D3SeaUrchin;
